import { Component, inject } from '@angular/core';
import { InfoService } from './info.service';

@Component({
  selector: 'app-info',
  standalone: false,
  templateUrl: './info.component.html',
  styleUrl: './info.component.scss',
})
export class InfoComponent {
  objectKeys = Object.keys;
  private readonly InfoService = inject(InfoService);
  data: any[]=[];

  ngOnInit(): void {
    this.InfoService.findAll().subscribe((response) => {
      this.data = response || [];
    });
  }
}
